var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { elevation: "0" } },
    [
      _vm.exporting
        ? _c(
            "v-overlay",
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "primary" },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("input", {
        ref: "uploaderImage",
        staticClass: "d-none",
        attrs: { type: "file", accept: "image/*" },
        on: { change: _vm.onFileChangedImage },
      }),
      _c("utils-explainers-pop-edit", { ref: "utils-explainers-pop-edit" }),
      _c(
        "v-card",
        { attrs: { elevation: "0", outlined: "", width: "100%" } },
        [
          _c(
            "v-card-actions",
            { staticClass: "ma-2 pa-0" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "green white--text pr-5",
                  attrs: { elevation: "0" },
                  on: {
                    click: function ($event) {
                      return _vm.onPressCreate()
                    },
                  },
                },
                [
                  _c("v-icon", { staticClass: "mr-2" }, [_vm._v("mdi-plus")]),
                  _vm._v("Create New"),
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  staticClass: "orange white--text pr-5",
                  attrs: { loading: this.importing, elevation: "0" },
                  on: {
                    click: function ($event) {
                      return _vm.onPressAddImage()
                    },
                  },
                },
                [
                  _c("v-icon", { staticClass: "mr-2" }, [
                    _vm._v("mdi-image-plus"),
                  ]),
                  _vm._v("Import Image"),
                ],
                1
              ),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "blue white--text pr-3",
                  attrs: { loading: this.exporting, elevation: "0" },
                  on: {
                    click: function ($event) {
                      return _vm.onPressExport()
                    },
                  },
                },
                [
                  _c("v-icon", { staticClass: "mr-2" }, [
                    _vm._v("mdi-clipboard-check-outline"),
                  ]),
                  _vm._v("Export"),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card",
        {
          staticClass: "mt-2 pa-0",
          attrs: { elevation: "0", outlined: "", width: "100%" },
        },
        [
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0" },
            [
              _c(
                "v-card",
                { attrs: { width: "100%", elevation: "0" } },
                [
                  _c(
                    "v-card-title",
                    [
                      _c("v-text-field", {
                        attrs: {
                          outlined: "",
                          "append-icon": "mdi-magnify",
                          label: "Search",
                          "single-line": "",
                          clearable: "",
                          "hide-details": "",
                          dense: "",
                        },
                        model: {
                          value: _vm.search,
                          callback: function ($$v) {
                            _vm.search = $$v
                          },
                          expression: "search",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-data-table", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      "fixed-header": "",
                      items: _vm.getData,
                      headers: _vm.headers,
                      search: _vm.search,
                      "single-select": false,
                      "item-key": "key",
                      "hide-default-footer": "",
                      "show-select": "",
                      "disable-pagination": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.key",
                        fn: function ({ item }) {
                          return [
                            _c("v-card-text", { staticClass: "blue--text" }, [
                              _vm._v(_vm._s(item.key)),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "item.addon.type.id",
                        fn: function ({ item }) {
                          return [
                            item.addon.type.id != 0
                              ? _c(
                                  "v-chip",
                                  { attrs: { color: "orange", dark: "" } },
                                  [_vm._v(_vm._s(item.addon.type.name))]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "item.pages",
                        fn: function ({ item }) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(item.pages ? item.pages.length : 0) +
                                " "
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.custom_title",
                        fn: function ({ item }) {
                          return [
                            item.custom_title && item.custom_title.length != 0
                              ? _c(
                                  "v-chip",
                                  { attrs: { color: "green", dark: "" } },
                                  [_vm._v(" true")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "item.actions",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "mr-1",
                                                  attrs: {
                                                    icon: "",
                                                    color: "green",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onPressEdit(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { size: "22" } },
                                                [_vm._v("mdi-pencil")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [_c("span", [_vm._v("Edit explainer")])]
                            ),
                            _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "mr-1",
                                                  attrs: {
                                                    icon: "",
                                                    color: "red",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onPressDelete(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { size: "22" } },
                                                [_vm._v("mdi-delete")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [_c("span", [_vm._v("Delete explainer")])]
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.selected,
                      callback: function ($$v) {
                        _vm.selected = $$v
                      },
                      expression: "selected",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }